export default __webpack_public_path__ + "static/media/man_mode.c772d0e2.png";